module.exports = __webpack_public_path__ + "img/panda.12441640.svg";